import { setTimeout } from "core-js";
import {
  absentTurn,
  callTurn,
  callTurnById,
  reCallTurn,
  cancelTurnManager,
  finishTurn,
  getAllTurns,
  getCompanyInfo,
  getDerivableQueueGroups,
  getqueueCompanyPost,
  getQueueTurns,
  getSelectedQueue,
  getTurnDataToCall,
  getWorkerStats,
  loggedUser,
  requeueManager,
  revokeTurn,
  updateState,
  workPlace,
  getAbstenTurns,
  autoRefreshToken,
  getUsers,
  tracking,
  sendNotification,
} from "../../helpers/fetching";



export default {
  state: {
    loggedUserData: {},
    workplaceData: {},
    callData: undefined,
    callDataTemp: undefined,
    finishCall: {},
    loadingState: false,
    derivableQueueGroups: [],
    allTurns: [],
    selectedQueueState: null,
    updateStateValue: null,
    debqMobile_turn: undefined,
    statsWorker: null,
    loading: false,
    error: null,
    errorForce: null,
    turnsQueue: null,
    turnDataToCall: null,
    absentTurns: [],
    response: null,
    firstTurn: null,
    mediaRecorder: {},
    users: [],
    tracking: null,
    errorCalling: null,
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setError(state, data) {
      if (!data) state.error = "error";
      else state.error = data;
    },
    setErrorCalling(state, data) {
      state.errorCalling = data;
    },
    setFinishCall(state, data) {
      state.finishCall = data;
      state.loading = false;
      state.error = null;
    },
    setErrorForce(state, data) {
      state.errorForce = data;
    },
    setLoading(state, data) {
      state.loading = data;
      state.error = null;
    },
    setMediaRecorder(state, data) {
      state.mediaRecorder = data;
    },
    setLoggedUserData(state, data) {
      state.loggedUserData = data;
      state.loading = false;
      state.error = null;
    },
    setLoadingState(state, data) {
      state.loadingState = data;
    },
    setCallTurn(state, data) {
      state.callData = data;
      state.loading = false;
      state.error = null;
    },
    setTempCallTurn(state, data) {
      state.callDataTemp = data;
      state.loading = false;
      state.error = null;
    },
    setReCallResponse(state, data) {
      state.response = data;
      state.loading = false;
      state.error = null;
    },
    setDebq(state, data) {
      state.debqMobile_turn = data;
      state.loading = false;
      state.error = null;
    },
    setStatsWorker(state, data) {
      state.statsWorker = data;
      state.loading = false;
      state.error = null;
    },
    setUpdateState(state, data) {
      state.updateStateValue = data;
    },
    setderivableQueueGroups(state, data) {
      state.derivableQueueGroups = data;
    },
    setselectedQueueState(state, data) {
      state.selectedQueueState = data;
    },
    setAllTurns(state, data) {
      state.allTurns = data;
    },
    setTurnsQueue(state, data) {
      state.turnsQueue = data;
    },
    setTurnDataToCall(state, data) {
      state.turnDataToCall = data;
    },
    setAbstenTurns(state, data) {
      state.absentTurns = data;
    },
    setFirstTurn(state, data) {
      state.firstTurn = data;
    },
    setUsers(state, data) {
      state.users = data;
    },
    setResponseTracking(state, data) {
      state.tracking = data;
    },
  },
  actions: {
    async loggedUserGetAction(
      { dispatch, commit },
      { branchId, workerId, force }
    ) {
      commit("clearError");
      commit("setLoading", true);
      if (force) commit("setErrorForce", null);
      const workplaceResponse = await workPlace({
        branchId,
        workerId,
        force,
      }).catch((error) => {
        // .catch((e) => {
        //   console.log(e);
        //   if (
        //     e ==
        //     "User is not authorized to access this resource with an explicit deny" ||
        //     e == 401
        //   ) {
        //     auditlogout();
        //     localStorage.removeItem("userInfo");
        //     location.reload();
        //   }
        // });;
        console.error(error);
        if (error == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          window.location.href = "/sessions/login";
        }
        if (
          error ==
          "User is not authorized to access this resource with an explicit deny"
        ) {
          dispatch("checkToken");
          setTimeout(() => {
            dispatch("loggedUserGetAction", {
              branchId: branchId,
              workerId: workerId,
              force: force,
            });
          }, 2000);
        } else {
          commit("setErrorForce", error);
        }
      });
      if (!workplaceResponse) return;
      loggedUser()
        .then((response) => {
          commit("setLoggedUserData", response);
          if (response.worker?.actualTurn) {
            commit("setCallTurn", response.worker?.actualTurn);
          }
        })
        .catch((error) => {
          console.error(error);
          commit("setError", error);
        });
    },
    callTurnAction({ commit }, params) {
      return new Promise((resolve) => {
        commit("clearError");
        commit("setLoading", true);
        return callTurn(params)
          .then((response) => {
            commit("setFirstTurn", response);
            if (!params.automaticCall) {
              commit("setCallTurn", response);
            } else {
              commit("setTempCallTurn", response);
            }

            // send user notification
            console.log(response);
            sendNotification(response.code);

            commit("setLoading", false);
            resolve(true);
          })
          .catch((error) => {
            console.error(error);
            commit("setError", error);
            commit("setLoading", false);
            resolve(error);
          });
      });
    },
    callTurnActionById({ commit }, options) {
      return new Promise((resolve) => {
        commit("clearError");
        commit("setLoading", true);
        return callTurnById(options)
          .then((response) => {
            commit("setCallTurn", response);
            commit("setLoading", false);
            sendNotification(response.code);
            commit("setErrorCalling", null);
            resolve(true);
          })
          .catch((error) => {
            console.error(error);
            commit("setError", error);
            commit("setErrorCalling", error);
            resolve(false);
          });
      });
    },
    reCallTurnAction({ commit }) {
      return new Promise((resolve) => {
        commit("clearError");
        commit("setLoading", true);
        return reCallTurn()
          .then((response) => {
            commit("setReCallResponse", response);
            commit("setLoading", false);
            sendNotification(response.code);
            resolve(true);
          })
          .catch((error) => {
            console.error(error);
            commit("setError", error);
            resolve(false);
          });
      });
    },
    async handlerDerivableQueueGroups({ commit }) {
      commit("setLoading", true);
      try {
        const responseQueue = await getDerivableQueueGroups();
        commit("setLoading", false);
        commit("setderivableQueueGroups", responseQueue);
      } catch (error) {
        console.error(error);
        commit("setLoading", false);
      }
    },
    async handlerSelectedQueue({ commit }, id) {
      commit("setLoading", true);
      try {
        const responseQueue = await getSelectedQueue(id);
        commit("setLoading", false);
        commit("setselectedQueueState", responseQueue);
      } catch (error) {
        console.error(error);
        commit("setError", error);
      }
    },
    addFirstTurnAction({ commit }, value) {
      commit("setFirstTurn", value);
    },
    finishTurnAction({ commit }, service_id = null) {
      return new Promise((resolve) => {
        commit("clearError");
        commit("setLoading", true);
        return finishTurn(service_id)
          .then((response) => {
            commit("setCallTurn", null);
            commit("setFinishCall", response);
            resolve(true);
          })
          .catch((error) => {
            console.error(error);
            commit("setError", error);
            resolve(false);
          });
      });
    },
    absentAction({ commit }) {
      absentTurn()
        .then((response) => {
          commit("setCallTurn", null);
          commit("setFinishCall", response);
        })
        .catch((error) => {
          console.error(error);
          commit("setError", error);
        });
    },
    reloadLoggedUserAction({ commit }) {
      loggedUser()
        .then((response) => {
          commit("setLoggedUserData", response);
          if (response.worker?.actualTurn) {
            commit("setCallTurn", response.worker?.actualTurn);
          }
        })
        .catch((error) => {
          console.error(error);
          commit("setError", error);
        });
    },
    revokeTurnAction({ commit }) {
      return new Promise((resolve) => {
        commit("clearError");
        commit("setLoading", true);
        revokeTurn()
          .then((response) => {
            commit("setCallTurn", null);
            commit("setFinishCall", response);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            commit("setError", error);
            resolve();
          });
      });
    },
    setCallData({ commit }, call) {
      commit("setCallTurn", call);
      commit("setTempCallTurn", null);
    },
    async getBeforeCall({ commit }, { defaultbranch }) {
      const companyInfo = await getCompanyInfo(defaultbranch);
      console.log(companyInfo);
      const response = await getqueueCompanyPost({ companyInfo });
      commit("setDebq", response);
    },
    async updateStateAction({ commit }, { id, name }) {
      /* eslint-disable */
      return new Promise(async resolve =>{
        commit("setLoadingState", true);
        await updateState({ id, name });
        commit("setUpdateState", name);
        await new Promise(r => setTimeout(() => r(), 1000) )
        commit("setLoadingState", false);
        resolve();
      })
      /* eslint-enable */
    },
    async handlerGetAllTurns({ commit }) {
      const allTurns = await getAllTurns();
      commit("setAllTurns", allTurns);
    },
    handlerGetAbstenTurns({ commit }) {
      getAbstenTurns()
        .then((allTurns) => {
          commit("setAbstenTurns", allTurns);
        })
        .catch((e) => {
          console.error(e);
          commit("setError", "Error");
        });
    },
    changeMediaRecorder({ commit }, value) {
      commit("setMediaRecorder", value);
    },
    getWorkerStatsAction({ commit }, idWorker) {
      commit("clearError");
      commit("setLoading", true);
      getWorkerStats(idWorker)
        .then((workerResponse) => {
          commit("setStatsWorker", workerResponse);
        })
        .catch((e) => {
          console.error(e);
          commit("setError", "Error");
        });
    },
    async cancelCall({ commit }) {
      return new Promise((resolve) => {
        cancelTurnManager()
          .then((response) => {
            commit("setCallTurn", response);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            commit("setError", error);
            resolve(error);
          });
      });
    },
    async handlerRequeueAction({ commit }) {
      await requeueManager();
      commit("setCallTurn", null);
    },
    async handlerGetTurnDataToCall({ commit }, id) {
      const turnCall = await getTurnDataToCall(id);
      commit("setTurnDataToCall", turnCall);
    },
    async handlerGetQueueTurns({ commit, state }, turn) {
      if (!state.loggedUserData.worker) return;
      // const turnQueues = turn.queues.find((turnVar) => turnVar.id);
      const callableGroup = 
      state.loggedUserData?.worker.callableQueueGroups ?
        state.loggedUserData?.worker.callableQueueGroups.find(
          (callG) => callG.id === turn.id
        ) :
        state.loggedUserData?.worker.orderedCallableQueueGroups.find(
          (callG) => callG.id === turn.id
        );
      if (!callableGroup) {
        console.log(callableGroup, state.loggedUserData, turn);
        return;
      }
      const turns = await getQueueTurns(callableGroup.id);
      commit("setTurnsQueue", turns);
    },
    async handleUsers({ commit }) {
      return new Promise((resolve) => {
        commit("clearError");
        commit("setLoading", true);
        getUsers()
          .then((users) => {
            commit("setUsers", users);
            resolve();
          })
          .catch((e) => {
            console.error(e);
            commit("setError", "Error");
            resolve();
          });
      });
    },
    checkToken() {
      autoRefreshToken();
    },
    setAsesorState({ commit }, name) {
      commit("setUpdateState", name);
    },
    sendtracking({ commit }, data) {
      return new Promise((resolve) => {
        commit("clearError");
        commit("setLoading", true);
        tracking(data)
          .then((response) => {
            commit("setResponseTracking", response);
            resolve();
          })
          .catch((e) => {
            console.error(e);
            commit("setErrorTracking", "Error");
            resolve();
          });
      });
    },
    async workerPlaceWaitingRoom({ commit, dispatch }, waitingRoomId) {
      workPlace({ waitingRoom: waitingRoomId }).catch((error) => {
        console.error(error);
        if (error == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          window.location.href = "/sessions/login";
        }
        if (
          error ==
          "User is not authorized to access this resource with an explicit deny"
        ) {
          dispatch("checkToken");
          setTimeout(() => {
            dispatch("workerPlaceWaitingRoom", waitingRoomId);
          }, 2000);
        } else {
          commit("setErrorForce", error);
        }
      });
    },
    clearAllData({ commit }) {
      commit("clearError");
      commit("setLoading", false);
      commit("setStatsWorker", null);
      commit("setUpdateState", null);
      commit("setDebq", null);
      commit("setCallTurn", null);
      commit("setTempCallTurn", null);
      commit("setFinishCall", null);
      commit("setLoggedUserData", null);
      commit("setErrorForce", null);
    },
    resetCallData({ commit }) {
      commit("setCallTurn", null);
      commit("setTempCallTurn", null);
      commit("setFirstTurn", null);
      commit("setFinishCall", null);
    },
    resetErrorCalling({ commit }) {
      commit("setErrorCalling", null);
      commit("setErrorForce", null);
    },
  },
};
